import { render, staticRenderFns } from "./FcChart.vue?vue&type=template&id=133cec9f&"
import script from "./FcChart.vue?vue&type=script&lang=js&"
export * from "./FcChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports